export default __webpack_public_path__ + "static/media/calendar1.8680be78.jpg";